
// * ========================================================================
// * municipality data
// * ========================================================================

import dataLoader from './../data-loader';

const municipalityData = (function(){

    function loadSelectedMunicipalities(data, selected, callback) {
        const dataEndpoints = [];
        const dataEndpointsParams = [];
        for (let item of selected) {
            const selectedName = data.municipalityIdMap[item];
            if (!(selectedName && typeof data.municipality !== 'undefined' && typeof data.municipality[selectedName] !== 'undefined')) {
                dataEndpoints.push('municipality'); // each municipality has its own request
                dataEndpointsParams.push({ municipality: selectedName });
            }
        }

        if (dataEndpointsParams.length) {
            dataLoader.loadEndpointData(data, dataEndpoints, callback, null, dataEndpointsParams);
        } else {
            callback();
        }
    }

    return {
        load: loadSelectedMunicipalities
    }

})();

export default municipalityData;
